import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const IonPageWrapper = styled(IonPage)`
  ion-content {
    --background: linear-gradient(rgba(100, 100, 100, 0.1), rgba(100, 100, 100, 0.7)), url('assets/bg.jpg') no-repeat center/cover fixed;
  }

  .login-card {
    border-radius: 20px;
    max-width: 50rem;
    min-height: 80%;
    margin-top: 5vw;
    margin-right: auto;
    margin-left: auto;
    padding: 20px;

    background: rgba(64, 59, 48, 0.55);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);

    border: none;
  }

  .row-button {
    margin-top: 45px;
    ion-button {
      --background: linear-gradient(0deg, #68b8fc 0%, #5ca2de 100%);
      --border-color: #fff;
      border-radius: 30px;
      --box-shadow: 0;
      color: #fff;
      font-family: 'Orbitron' !important;
    }
  }

  .input-group {
    border-radius: 15px;
    margin-bottom: 20px;
    border: 1px solid var(--ion-color-light);
    padding: 0px;

    ion-icon {
      /* color: #fff; */
    }
  }

  ion-item {
    padding-left: 15px;
    --background: transparent;
    --border-color: var(--ion-color-light);
    --color: var(--ion-color-light);
    --padding-start: 0px;
    .label {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 800px) {
    .login-card {
      width: 100%;
      border-radius: 0;
      margin: 0;
      min-height: 100vh;
    }
  }
`;
